import { resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, mergeProps as _mergeProps, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<footer class=\"site-footer\"><div class=\"footer-inner\"><nav class=\"footer-nav\"><a href=\"https://raffishagency.com/privacy-policy/\" target=\"_blank\" rel=\"noopener noreferrer\"> Terms &amp; Conditions </a></nav><div class=\"footer-legal\"> Copyright © 2025 Raffish Agency </div></div></footer>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_help_window = _resolveComponent("help-window")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.$route.meta.layout), { onHelp: _ctx.showHelp }, {
      default: _withCtx(() => [
        _createVNode(_component_router_view)
      ]),
      _: 1
    }, 40, ["onHelp"])),
    _hoisted_2,
    (_ctx.help.show)
      ? (_openBlock(), _createBlock(_component_help_window, _mergeProps({
          key: 0,
          onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.help.show = false))
        }, _ctx.help.data), null, 16))
      : _createCommentVNode("", true)
  ]))
}